import { ReturnRequestLineItemDto } from "@babackapp/private-api-client/types";

export type GetLineItemTreatedByMerchantQuantityParams = {
  lineItem: ReturnRequestLineItemDto;
};

/**
 * A Line item can be split into different parts in the context of a return request.
 * This function returns the quantity of the line item that has been treated by the merchant.
 * (reject/validate)
 *
 * For example, the order contains 3 white t-shirt
 *
 * ***********************************
 * White t-shirt                   x3
 * ***********************************
 *
 * The customer returns 3 white t-shirt.
 * The logistician has rejected 1 white t-shirt.
 * The merchant has validated 1 white t-shirt.
 * The merchant has rejected 1 white t-shirt.
 *
 * This function would return 2 (item treated by merchant)
 */
export function getLineItemTreatedByMerchantQuantity({
  lineItem,
}: GetLineItemTreatedByMerchantQuantityParams) {
  return lineItem.merchant_informations.reduce(
    (acc, merchantInformation) => acc + merchantInformation.quantity,
    0
  );
}
